module.exports = __webpack_public_path__ + "img/case-details-icon-02.060ca681.png";